import { useLazyQuery, useMutation } from '@apollo/client';
import { useLocation, useNavigate } from 'react-router-dom';
import FileUpload from '../../components/Popups/FileUpload';
import './PodCast.scss';
import { useCallback, useEffect, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import LibraryHeader from '../../components/LibraryHeader/LibraryHeader';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import ToasterWithMessage from '../../components/toaster';
import { useAppSelector } from '../../redux/app/hooks';
import QuestionBankList from '../../components/QuestionBankList/QuestionBankList';
import { DELETE_IMAGES_PODCASTS, UPDATE_IMAGES_PODCASTS, UPLOAD_LIBRARY_IMAGE, VIEW_ALL_LIBRARY_IMAGES } from '../ImageMaterial/api/ImageMaterialQuery';
import { debounce } from 'lodash';
import SingleAudioPlay from '../../components/SingleAudioPlay/SingleAudioPlay';
import { materialsData } from '../../utils/interface';
import { STUDENT_ROLE } from '../../utils/constants';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { getScreenDimensions } from '../../utils/helper';
import images from '../../assets/images';

const PodCast = () => {
    const [podCastUrl, setPodCastUrl] = useState<string>();
    const [podcastCoverUrl,setPodcastCoverUrl] = useState<string>();
    const [podCastFilename, setPodCastFilename] = useState<string>();
    const [podcastDescription,setPodcastDescription] = useState<string>();
    const [podCastPdfFileData, setPodCastPdfFileData] = useState<materialsData | undefined>();
    const [podCastFileData, setPodCastFileData] = useState<File | null>();
    const [isPodCastUploadOpen, setIsPodCastUploadOpen] = useState<boolean>(false);
    const [podCastOpen, setPodCastOpen] = useState<boolean>(false);
    const [podCastOpenPdf, setPodCastOpenPdf] = useState(false);
    const [podCastData, setPodCastData] = useState<materialsData[]>();
    const [podCastUploadProgress, setPodCastUploadProgress] = useState(0);
    const [podCastUploadFailed, setPodCastUploadFailed] = useState<boolean>(false);
    const [podCastUploadFileName, setPodCastUploadFileName] = useState<string>('');
    const [podCastUploaded, setPodCastUploaded] = useState(false);
    const [podCastSearchValue, setPodCastSearchValue] = useState<string>('');
    const { success, error } = ToasterWithMessage();
    const { state } = useLocation();
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const selectedLibraryId = localStorage.getItem('selectedLId');
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const role = useAppSelector((state) => state.auth.role);
    const navigate = useNavigate();
    const backNavigation = (role === STUDENT_ROLE) ? '/student-classroom/podcast' : '/teacher-classroom/podcast';
    const [refetch, SetRefetch] = useState<boolean>(false);
    const [shared, setShared] = useState<string>();
    const profile = useAppSelector((state) => state.auth.adminProfile);
    const {uploadCloud} = images;

    const [uploadPodcast] = useMutation(UPLOAD_LIBRARY_IMAGE, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.uploadMylibraryImagesAndPodcasts) {
                setPodCastFileData(null);
                if (podCastFilename) {
                    setPodCastUploadFileName(podCastFilename);
                }
                setPodCastUploaded(true);
                setPodcastCoverUrl('');
                setPodcastDescription('');
                setPodCastUploadProgress(100);
                setPodCastFilename('');
                setPodCastUrl('');
                SetRefetch(!refetch);
            }
        },
        onError: (err) => {
            if (podCastFilename) {
                setPodCastUploadFileName(podCastFilename);
            }
            setPodCastUploaded(true);
            setPodCastUploadProgress(0);
            setPodCastUploadFailed(true);
        }
    });

    const [getAllPodcast, { loading }] = useLazyQuery(VIEW_ALL_LIBRARY_IMAGES, {
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            if (data?.getMylibraryImagesPodcastsInfo?.nodes) {
                setPodCastData(data?.getMylibraryImagesPodcastsInfo?.nodes);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/podcast', { state: { title: 'Podcast' } });
                    } else {
                        navigate('/teacher-classroom/podcast', { state: { title: 'Podcast' } });
                    }
                }, 2000);
            }
        }
    });


    const [readFeed] = useMutation(READ_CLASSROOMUPDATES, {
        fetchPolicy: 'network-only',
        onCompleted : (data) =>{
        },
        onError: (err) =>{
          console.log(err.message)
        }
      })
    
      useEffect(()=>{
    if(role === STUDENT_ROLE){
      if(podCastData && podCastData.length > 0){
        podCastData?.forEach((data) => {
          if (data.feedId) {
            readFeed({
              variables: {
                fId: data.feedId,
                uId: profile?.getCurrentUser?.nodes[0]?.uId
              }
            })
          }
        });
      }
    }
      },[podCastData, profile?.getCurrentUser?.nodes, readFeed, role])

    const [updatePodcast] = useMutation(UPDATE_IMAGES_PODCASTS, {
        fetchPolicy: "no-cache",
        onCompleted: () => {
            SetRefetch(!refetch);
            success(`${shared} successfully`);
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/podcast', { state: { title: 'Podcast' } });
                    } else {
                        navigate('/teacher-classroom/podcast', { state: { title: 'Podcast' } });
                    }
                }, 2000);
            }
        }
    })

    const [deletePodcast] = useMutation(DELETE_IMAGES_PODCASTS, {
        fetchPolicy: "no-cache",
        onCompleted: () => {
            SetRefetch(!refetch);
            success("Deleted successfully");
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/podcast', { state: { title: 'Podcast' } });
                    } else {
                        navigate('/teacher-classroom/podcast', { state: { title: 'Podcast' } });
                    }
                }, 2000);
            }
        }
    })


    useEffect(() => {
        getAllPodcast({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                cId: selectedClassRoomId,
                limit: null,
                offset: null,
                searchInput: `%${podCastSearchValue.trim()}%`,
                ...(role === STUDENT_ROLE && { isClassroom: true })
            }
        });
    }, [refetch]);

    useEffect(() => {
        if (podCastFileData && podCastFilename && podCastFilename !== '' && podCastUrl && podcastDescription) {
            uploadPodcast({
                variables: {
                    cId: selectedClassRoomId,
                    filename: podCastFilename?.replace(/\.mp3$/, ""),
                    filepath: podCastUrl,
                    filesize: podCastFileData?.size,
                    fileDescription: podcastDescription,
                    coverImagePath: podcastCoverUrl ? podcastCoverUrl : null,
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                }
            });
        }
    }, [podCastFileData, podCastFilename, podCastUrl, podcastDescription]);

    //To open pdf in detailed view
    const handleOpenFile = (podcastData: materialsData) => {
        setPodCastOpenPdf(true);
        setPodCastPdfFileData(podcastData);
    }

    //To close pdf detailed view
    const handleClosePdf = () => {
        setPodCastOpenPdf(false);
        setPodCastPdfFileData(undefined);
        getAllPodcast({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                cId: selectedClassRoomId,
                limit: null,
                offset: null,
                searchInput: `%${podCastSearchValue.trim()}%`,
                ...(role === STUDENT_ROLE && { isClassroom: true })
            }
        });
    };

    const handleSearchDebounce = useCallback(
        debounce((value) => {
            setPodCastSearchValue(value);
            getAllPodcast({
                variables:{
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId:selectedClassRoomId,
                    limit: null,
                    offset: null,
                    searchInput: `%${value.trim()}%`,
                    ...(role === STUDENT_ROLE && { isClassroom: true })
                }
            });
        }, 500),
        [getAllPodcast]
    );
    
    //To done actions in podcast
    const handlePodcastActions = (data:materialsData,action:string) => {
        if (action === "delete") {
            deletePodcast({
                variables: {
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            })
        }
        else if (action === "share" || "unshare") {
            setShared(data?.isclassroom ? "Unshared" : "Shared");
            updatePodcast({
                variables: {
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassRoomId,
                    isClassroom: !data?.isclassroom,
                    fId: data?.fileId
                }
            })
        }
    }

    //To open upload popup in mobile screen
       const handleOpenUpload = () => {
        setIsPodCastUploadOpen(true);
        setPodCastOpen(true);
    };

    return (
        <div className="PodCast">
            <LibraryHeader
                image={state?.imageSrc}
                backgroundColor={state?.backGroundColor}
                subject={state?.title}
                subCategory={'Podcast'}
                setIsUploadOpen={setIsPodCastUploadOpen}
                openPdf={podCastOpenPdf}
                onClose={handleClosePdf}
                setOpen={setPodCastOpen}
                backNavigation={{ path: backNavigation, state: { title: "Podcast" } }}
                handleSearchDebounce={handleSearchDebounce}
                searchValue={podCastSearchValue}
                setSearchValue={setPodCastSearchValue}
            />
            {
                podCastOpenPdf ?
                    <SingleAudioPlay podCastPdfFileData={podCastPdfFileData}/>
                    :
                    <>
                        {
                            loading ? <Loader bottom='165px' />
                                :
                                <div className='PodCastBody'>
                                    <QuestionBankList
                                        type="Podcast"
                                        subject={state?.title}
                                        subCategory={`Podcast`}
                                        questionBankData={podCastData}
                                        handleOpenFile={handleOpenFile}
                                        handleMaterialActions={handlePodcastActions}
                                        setRefetch={SetRefetch}
                                    />
                                </div>
                        }
                    </>
            }
            {/* {isPodCastUploadOpen && <FileUpload name = "PodcastMaterial" type='audio' setPodcastDescription = {setPodcastDescription} setCoverImageUrl ={setPodcastCoverUrl} setUrl={setPodCastUrl} open={podCastOpen} setOpen={setPodCastOpen} folderName="materials" setFilename={setPodCastFilename} setFileData={setPodCastFileData} />} */}
            {isPodCastUploadOpen && <FileUpload name = "PodcastMaterial" type='audio' setPodcastDescription = {setPodcastDescription} setCoverImageUrl ={setPodcastCoverUrl} setUrl={setPodCastUrl} open={podCastOpen} setOpen={setPodCastOpen} setIsUploadOpen={setIsPodCastUploadOpen} folderName="materials" setFilename={setPodCastFilename} setFileData={setPodCastFileData} setUploadFailed={setPodCastUploadFailed} setUploadProgress={setPodCastUploadProgress} setuploaded={setPodCastUploaded} setUploadFileName={setPodCastUploadFileName} />}
            {podCastUploaded && <UploadToaster uploaded={podCastUploaded} setuploaded={setPodCastUploaded} uploadProgress={podCastUploadProgress} setUploadProgress={setPodCastUploadProgress} fileName={podCastUploadFileName} setUploadFileName={setPodCastUploadFileName} uploadFailed={podCastUploadFailed} setUploadFailed={setPodCastUploadFailed} />}
            {(getScreenDimensions()?.isMobileScreen && role !== STUDENT_ROLE) && !podCastOpenPdf &&
            <div className='libraryHeaderUploadContainer'> 
            <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
             <img src={uploadCloud} alt="upload" className='uploadImage' />
            </div>
            </div>}
        </div>
    )
}

export default PodCast;
